import { render, staticRenderFns } from "./goods-category-filter.vue?vue&type=template&id=59037b55&"
import script from "./goods-category-filter.vue?vue&type=script&lang=ts&"
export * from "./goods-category-filter.vue?vue&type=script&lang=ts&"
import style0 from "./goods-category-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports